(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["etchedworks-editorial-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-gift-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-gift-track]');
    const viewport = carousel.querySelector('[data-gift-viewport]');
    const seenProducts = new Set();
    Array.from(track.children).forEach((card) => {
      const productId = card.dataset.productId;
      if (seenProducts.has(productId)) card.remove();
      else seenProducts.add(productId);
    });
    const cards = Array.from(track.children);
    for (let index = cards.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(Math.random() * (index + 1));
      [cards[index], cards[randomIndex]] = [cards[randomIndex], cards[index]];
    }
    cards.forEach((card) => track.appendChild(card));

    const advance = (direction) => {
      const card = track.querySelector('.etchedworks-gift-card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      viewport.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    };

    carousel.querySelector('[data-gift-previous]').addEventListener('click', () => advance(-1));
    carousel.querySelector('[data-gift-next]').addEventListener('click', () => advance(1));

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let timer = window.setInterval(() => {
        const atEnd = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 4;
        if (atEnd) viewport.scrollTo({ left: 0, behavior: 'smooth' });
        else advance(1);
      }, 6000);
      const pause = () => window.clearInterval(timer);
      carousel.addEventListener('mouseenter', pause, { once: true });
      carousel.addEventListener('focusin', pause, { once: true });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["etchedworks-featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ew-featured [data-carousel-group]').forEach((group) => {
    const carousel = group.querySelector('[data-product-carousel]');
    const previous = group.querySelector('[data-carousel-previous]');
    const next = group.querySelector('[data-carousel-next]');
    if (!carousel || !previous || !next) return;
    const move = (direction) => {
      const card = carousel.querySelector('.ew-featured__product');
      if (!card) return;
      const gap = Number.parseFloat(getComputedStyle(carousel).gap) || 0;
      const distance = (card.getBoundingClientRect().width + gap) * direction;
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      carousel.scrollBy({ left: distance, behavior });
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["etchedworks-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ew-site-header__desktop details').forEach((menu) => {
    if (menu.dataset.ewHoverReady) return;
    menu.dataset.ewHoverReady = 'true';

    let closeTimer;
    const nav = menu.closest('.ew-site-header__desktop');
    const summary = menu.querySelector(':scope > summary');
    const usesHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    const overviewLink = menu.parentElement?.classList.contains('ew-site-header__nav-pair') ? menu.previousElementSibling : null;

    const openMenu = () => {
      window.clearTimeout(closeTimer);
      nav?.querySelectorAll('details[open]').forEach((item) => {
        if (item !== menu) item.open = false;
      });
      menu.open = true;
    };

    const closeMenu = () => {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        if (!menu.matches(':hover') && !overviewLink?.matches(':hover') && !menu.contains(document.activeElement) && document.activeElement !== overviewLink) {
          menu.open = false;
        }
      }, 160);
    };

     if (menu.classList.contains('ew-site-header__awards-menu') || menu.classList.contains('ew-site-header__drinkware-menu') || menu.classList.contains('ew-site-header__barware-menu') || menu.classList.contains('ew-site-header__bottles-menu') || menu.classList.contains('ew-site-header__gifts-menu') || menu.classList.contains('ew-site-header__division-menu')) {
       overviewLink?.addEventListener('mouseenter', () => {
        if (usesHover.matches) openMenu();
      });
      menu.addEventListener('mouseenter', () => {
        if (usesHover.matches) openMenu();
      });
      overviewLink?.addEventListener('mouseleave', closeMenu);
      menu.addEventListener('mouseleave', closeMenu);
      menu.addEventListener('focusin', openMenu);
      menu.addEventListener('focusout', closeMenu);
      summary?.addEventListener('click', (event) => {
        event.preventDefault();
        if (menu.open) menu.open = false; else openMenu();
      });
      document.addEventListener('click', (event) => {
        if (!menu.contains(event.target) && event.target !== overviewLink) menu.open = false;
      });
    } else {
      menu.addEventListener('mouseenter', () => {
        if (usesHover.matches) openMenu();
      });
      menu.addEventListener('mouseleave', () => {
        if (usesHover.matches) closeMenu();
      });
      menu.addEventListener('focusin', openMenu);
      menu.addEventListener('focusout', closeMenu);
    }
    menu.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        menu.open = false;
        summary?.focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["etchedworks-product-main"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const price = section.querySelector('[data-product-price]');
    const sku = section.querySelector('[data-product-sku]');
    const variantRadios = section.querySelectorAll('[data-variant-radio]');



    const quoteLink = section.querySelector('[data-ew-quote-link]');

    variantRadios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        if (price) price.textContent = radio.dataset.price;
        if (sku) sku.textContent = radio.dataset.sku ? `SKU ${radio.dataset.sku}` : '';
        if (quoteLink) { const quoteUrl = new URL(quoteLink.href); quoteUrl.searchParams.set('variant', radio.value); quoteLink.href = quoteUrl.toString(); }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url);
      });
    });


    const copyButton = section.querySelector('[data-copy-product-link]');
    const copyStatus = section.querySelector('[data-copy-status]');
    copyButton?.addEventListener('click', async () => {
      try { await navigator.clipboard.writeText(window.location.href); if (copyStatus) copyStatus.textContent = 'Link copied'; window.setTimeout(() => { if (copyStatus) copyStatus.textContent = ''; }, 2200); }
      catch (error) { if (copyStatus) copyStatus.textContent = 'Copy the page address from your browser'; }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
